import { Col, Form, Input, Row } from "antd";
import { FormItemHiddenUi } from "../../../ui";

export const CentroCostoForm = () => {
  return (
    <>
      <FormItemHiddenUi name="id" />
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={24}>
          <Form.Item
            label="Código"
            name="codigo"
            rules={[{ required: true, message: "El código es obligatorio" }]}
          >
            <Input maxLength="20" min={0} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={24}>
          <Form.Item
            label="Nombre"
            name="nombre"
            rules={[{ required: true, message: "El nombre es obligatorio" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
